module.exports = __webpack_public_path__ + "img/sawMan.f8c74aa2.png";